(function ($) {
    var win = $(window),
        doc = $(document),
        wrap = $('.wrapp'),
        body = $('body');

    doc.ready(function () {
        navigationMenus();
        mobileSubMenu();
        stickyHeader();
        industrySlider();
        testimonialsSlider();
        scrollToAnchor();
        toggleStaff();
        storySlider();
        toggleMore();
        buttonsSlider();
        tocToggle();
        supportSearch();
        productSlider();
        toggleMoreProductDescirption();
        tabsToggle();
        tsToggle();
        relatedSlider();
        productSearch();
        productType();
        toggleBrands();
        inquiryList();
        archiveProductHeight();
        AOS.init();
    });
    win.on('scroll', function () {
        stickyHeader();
    });
    win.on('resize', function () {
        archiveProductHeight();
    });
    doc.on('touchmove', function () {
        stickyHeader();
    });

// mobile menu
    function navigationMenus() {
        $('.mobile-nav-btn').on('click', function () {
            $(this).toggleClass('is-active');
            $('.site-header .menu--mobile').toggleClass('is-active');
        });
    }

    function mobileSubMenu() {
        var eachMenu = $(".site-header .menu-item-has-children"),
            animateTime = 200,
            burgerBtn = '<span class="burger-sub-menu"></span>';

        eachMenu.each(function () {
            // $(this).append($(burgerBtn));
            $(this).find('.sub-menu').before($(burgerBtn));
        });

        eachMenu.on('click', '.burger-sub-menu', function (e) {
            $('.sub-menu').stop().animate({height: '0'}, 0);
            $('.burger-sub-menu').removeClass('active');

            if ($(this).parent().find('.sub-menu').height() === 0) {
                autoHeightAnimate($(this).parent().find('.sub-menu'), 0);
                $(this).parent().find('.burger-sub-menu').addClass('active');
            } else {
                $(this).parent().find('.sub-menu').stop().animate({height: '0'}, 0);
                $(this).parent().find('.burger-sub-menu').removeClass('active');
            }

            function autoHeightAnimate(element, time) {
                var curHeight = element.height(), // Get Default Height
                    autoHeight = element.css('height', 'auto').height(); // Get Auto Height
                element.height(curHeight); // Reset to Default Height
                element.stop().animate({height: autoHeight}, time); // Animate to Auto Height
            }
        });
    }

    function industrySlider() {
        $('.slider__sliders').slick({
            infinite: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            dots: false,
            prevArrow: '<button type="button" class="slick-prev"></button>',
            nextArrow: '<button type="button" class="slick-next"></button>',
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '60px',
                        slidesToShow: 3,
                        infinite: true,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '60px',
                        slidesToShow: 1,
                        infinite: true,
                    }
                },
                {
                    breakpoint: 374,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '30px',
                        slidesToShow: 1,
                        infinite: true,
                    }
                },
            ]
        });
    }

    function testimonialsSlider() {
        $('.testimonials__slider').slick({
            infinite: true,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev"></button>',
            nextArrow: '<button type="button" class="slick-next"></button>',
        });
    }

    function stickyHeader() {
        if (win.scrollTop() > 0) {
            $('.site-header').addClass('sticky');
        } else {
            $('.site-header').removeClass('sticky');
        }
        if ($('.menu-widget').length > 0) {
            let menuTop = $('.menu-widget').offset().top;
            if (win.scrollTop() > menuTop - 75 && win.width() > 768) {
                $('.menu-widget .widget-content').addClass('sticky');
            } else {
                $('.menu-widget .widget-content').removeClass('sticky');
            }
        }
    }

    function scrollToAnchor() {
        $('.anchors__list a').on('click', function (e) {
            e.preventDefault();

            let aTag = $($(this).attr('href'));
            $('html,body').animate({scrollTop: aTag.offset().top - 75}, 'slow');
        });

        $('.anchors__item').on('click', function (e) {
            e.preventDefault();

            let aTag = $($(this).attr('href'));
            $('html,body').animate({scrollTop: aTag.offset().top - 75}, 'slow');
        });

        $(window).scroll(function () {
            if ($("#anchor-2").length) {
                if ($("#anchor-2").inView()) {
                    $('.anchors__item').addClass('active');
                } else {
                    $('.anchors__item').removeClass('active');
                }
            }
        });
    }

    function toggleStaff() {
        $('.departments__item_name').on('click', function (e) {
            e.preventDefault();

            let $this = $(this);
            $this.addClass('active');
            $this.siblings('.departments__item_row').slideDown();
        });

        let staffDesc = $('.leaders__item_content_description');
        if (staffDesc !== undefined && staffDesc.length > 0) {
            if (staffDesc[0].scrollHeight > staffDesc.height()) {
                staffDesc.siblings('.leaders__item_content_description__button').addClass('active');
            }
        }

        $('.leaders__item_content_description__button').on('click', function (e) {
            e.preventDefault();

            let $this = $(this);
            $this.toggleClass('less');
            $this.siblings('.leaders__item_content_description').toggleClass('active');
        });
    }

    function storySlider() {
        $('.story_slider__sliders').each(function (key, item) {
            let sliderIdName = 'storySlider' + key;
            let sliderNavIdName = 'storySliderNav' + key;

            this.id = sliderIdName;
            $('.story_slider__sliders_nav')[key].id = sliderNavIdName;

            let sliderId = '#' + sliderIdName;
            let sliderNavId = '#' + sliderNavIdName;
            $(sliderNavId).slick({
                slidesToShow: 8,
                slidesToScroll: 1,
                asNavFor: sliderId,
                dots: false,
                arrows: false,
                centerMode: true,
                centerPadding: '0px',
                focusOnSelect: true,
                variableWidth: true,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 3,
                            variableWidth: false,
                            infinite: false,
                        }
                    },
                ]
            });
            $(sliderId).slick({
                infinite: true,
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
                asNavFor: sliderNavId,
                prevArrow: '<button type="button" class="slick-prev"></button>',
                nextArrow: '<button type="button" class="slick-next"></button>',
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            infinite: false,
                        }
                    },
                ]
            });
        });
    }

    function toggleMore() {
        var showChar = 333;  // How many characters are shown by default
        var ellipsestext = "...";
        var $showMoreButton = $('.text_left_image_right .content__button');

        $('.content__content').each(function () {
            var content = $(this).html();

            if (content.length > showChar) {

                var c = content.substr(0, showChar);
                var h = content.substr(showChar, content.length - showChar);

                var html = c + '<span class="moreellipses">' + ellipsestext + '</span><span class="morecontent"><span>' + h + '</span></span>';

                $(this).html(html);
            } else {
                $showMoreButton.hide();
            }

        });

        $showMoreButton.on('click', function (e) {
            e.preventDefault();

            if ($(this).hasClass("less")) {
                $(this).removeClass("less");
            } else {
                $(this).addClass("less");
            }

            $(this).prev().find('.moreellipses').toggle();
            $(this).prev().find('.morecontent').slideToggle('medium', function () {
                if ($(this).is(':visible'))
                    $(this).css('display', 'inline');
            });
            return false;
        });
    }

    function buttonsSlider() {
        $('.slider_with_buttons__sliders').slick({
            infinite: true,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev"></button>',
            nextArrow: '<button type="button" class="slick-next"></button>',
        });

        $('.slider_with_buttons__buttons_link').on('click', function (e) {
            e.preventDefault();

            let $buttonLinkThis = $(this);
            $buttonLinkThis.siblings('.slider_with_buttons__buttons_link').removeClass('active');
            $buttonLinkThis.addClass('active');
            let buttonLinkSliderId = $buttonLinkThis.data('slide-id');
            $buttonLinkThis.parents('.slider_with_buttons__buttons').siblings('.container').find('.slider_with_buttons__sliders').slick('slickGoTo', parseInt(buttonLinkSliderId), false);
        });

        $('.slider_with_buttons__sliders').on('afterChange', function (event, slick, currentSlide) {
            $(this).parents('.container').siblings('.slider_with_buttons__buttons').find('.slider_with_buttons__buttons_link').removeClass('active');
            $(this).parents('.container').siblings('.slider_with_buttons__buttons').find('.slider_with_buttons__buttons_link[data-slide-id="' + currentSlide + '"]').addClass('active');
        });
    }

    function tocToggle() {
        if (document.querySelector('#ez-toc-container')) {
            let elem = document.querySelector("#ez-toc-container");

            function getCookie(name) {
                let matches = document.cookie.match(new RegExp(
                    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
                ));
                return matches ? decodeURIComponent(matches[1]) : undefined;
            }

            if (getCookie('ezTOC_hidetoc') === 'null') {
                elem.classList.add("is-shown");
            } else if (getCookie('ezTOC_hidetoc') === '1') {
                elem.classList.add("is-hide");
            }

            $('.ez-toc-title-toggle').on('click', function () {
                $(this).toggleClass('active');
            });
        }
    }

    function supportSearch() {
        let currentPage = 1;
        $('#support-materials-form').on('submit', function (e) {
            e.preventDefault();

            var $supportLoader = $('.support__files_block__loader');

            $.ajax({
                url: dsflex_params.ajaxurl,
                type: 'post',
                data: {
                    action: 'support_search',
                    keywords: $('#search').val()
                },
                dataType: "html",
                beforeSend: function (xhr) {
                    $supportLoader.css('display', 'flex');
                },
                success: function (data) {
                    if (data) {
                        currentPage = 1;
                        $('.support__files_block .container').html(data);
                    }
                },
                complete: function (jqXHR) {
                    $supportLoader.css('display', 'none');
                }
            });
        });

        $('body').on('click', '.support .pagination a', function (e) {
            e.preventDefault();

            let $supportLoader = $('.support__files_block__loader');

            if ($(this).hasClass('next')) {
                currentPage += 1;
            } else if ($(this).hasClass('prev')) {
                currentPage -= 1;
            } else {
                currentPage = $(this).html();
            }

            $.ajax({
                url: dsflex_params.ajaxurl,
                type: 'post',
                data: {
                    action: 'support_search',
                    keywords: $('#search').val(),
                    page: currentPage
                },
                dataType: "html",
                beforeSend: function (xhr) {
                    $supportLoader.css('display', 'flex');
                },
                success: function (data) {
                    if (data) {
                        $('.support__files_block .container').html(data);
                    }
                },
                complete: function (jqXHR) {
                    $supportLoader.css('display', 'none');
                }
            });
        });
    }

    function productSlider() {
        $('.woocommerce-product-gallery__galleries').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.woocommerce-product-gallery__main',
            dots: false,
            arrows: false,
            focusOnSelect: true,
            vertical: true,
            verticalSwiping: true,
            adaptiveHeight: true,
            infinite: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 5,
                        vertical: false,
                        verticalSwiping: false,
                        adaptiveHeight: false,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                        vertical: false,
                        verticalSwiping: false,
                        adaptiveHeight: false,
                        dots: true,
                        centerMode: true,
                        centerPadding: '0px',
                    }
                },
            ]
        });
        $('.woocommerce-product-gallery__main').slick({
            infinite: false,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            asNavFor: '.woocommerce-product-gallery__galleries',
            prevArrow: '<button type="button" class="slick-prev"></button>',
            nextArrow: '<button type="button" class="slick-next"></button>',
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        infinite: false,
                    }
                },
            ]
        });

        let mainProductImageThumb = {
            infinite: false,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            prevArrow: '<button type="button" class="slick-prev"></button>',
            nextArrow: '<button type="button" class="slick-next"></button>',
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        infinite: false,
                    }
                },
            ]
        };

        $('.product__modal_images').slick(mainProductImageThumb);

        let singleProductImaheThumbTop = 0;
        $('.woocommerce-product-gallery__main_item').on('click', function (e) {
            let imageID = $(this).data('popup-id');
            $('#productImageModal').fadeIn().css('display', 'flex');
            $('.product__modal_images').slick('unslick').slick(mainProductImageThumb).slick('slickGoTo', imageID, true);
            singleProductImaheThumbTop = $(window).scrollTop();
            $('body').css({
                overflow: 'hidden',
                width: '100%',
                position: 'fixed',
            });
        });

        $('#productImageModal .close').on('click', function (e) {
            e.preventDefault();
            $('#productImageModal').fadeOut();
            $('body').css({
                overflow: '',
                width: '',
                position: '',
            });
            $('html, body').animate({scrollTop: singleProductImaheThumbTop}, 0);
        });
    }

    function toggleMoreProductDescirption() {
        var $showMoreProductButton = $('.product .summary__content_button');

        $showMoreProductButton.on('click', function (e) {
            e.preventDefault();

            if ($(this).hasClass("less")) {
                $(this).removeClass("less");
            } else {
                $(this).addClass("less");
            }

            $(this).prev().find('p:not(:first-of-type)').slideToggle('medium', function () {
                if ($(this).is(':visible'))
                    $(this).css('display', 'block');
            });
        });
    }

    function tabsToggle() {
        $('.tabs__list a').on('click', function (e) {
            e.preventDefault();

            let $tabsThis = $(this);
            let $tabsThisID = $tabsThis.data('target-tab-id');
            if (!$tabsThis.hasClass('active')) {
                $('.tabs__list a').removeClass('active');
                $tabsThis.addClass('active');

                $('.tabscontent').fadeOut().removeClass('active');
                $('.tabstitle a').removeClass('active');
                $('.tabscontent[data-tab-id="' + $tabsThisID + '"]').fadeIn().addClass('active');
                $('.tabstitle [data-target-tab-id="' + $tabsThisID + '"]').addClass('active');
            }
        });

        $('.tabstitle a').on('click', function (e) {
            e.preventDefault();

            $(this).toggleClass('active');
            $(this).parents('.tabstitle').next('.tabscontent').slideToggle();
        });
    }

    function tsToggle() {
        $('.collapse_title').on('click', function (e) {
            e.preventDefault();

            let $collapseThis = $(this);
            $collapseThis.toggleClass('active');
            $collapseThis.siblings('.collapse_list').slideToggle();
        });
    }

    function relatedSlider() {
        $('.related .products').slick({
            infinite: false,
            dots: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev"></button>',
            nextArrow: '<button type="button" class="slick-next"></button>',
            responsive: [
                {
                    breakpoint: 1449,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }

    // Archive Product
    let archiveProductSlickSettings = {
        infinite: false,
        dots: false,
        slidesToShow: 8,
        slidesToScroll: 8,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };

    function toggleBrands() {
        $('.archive-products__filter__tabs a').on('click', function (e) {
            e.preventDefault();

            let $tabsThis = $(this);
            let $tabsThisID = $tabsThis.data('target-tab-id');
            let $curSlickSlide = $('.archive-products__filter__content [data-tab-id="' + $tabsThisID + '"]').find('a.active').parents('.slick-slide').attr('data-slick-index');
            if (!$tabsThis.hasClass('active')) {
                $('.archive-products__filter__tabs a').removeClass('active');
                $tabsThis.addClass('active');

                $('.archive-products__filter__content > div').hide().removeClass('active');
                $('.archive-products__filter__content [data-tab-id="' + $tabsThisID + '"]').fadeIn().addClass('active');
                $('.archive-products__filter__content [data-tab-id="' + $tabsThisID + '"] .slick-slider').slick('unslick').slick(archiveProductSlickSettings).slick('slickGoTo', $curSlickSlide, true);
            }
        });
    }

    function productSearch() {
        if ($('body').hasClass('archive')) {
            let currentProdPage = 1;
            let catID = getUrlParams('product-type');
            let catBrandID = getUrlParams('product-type-brand');
            let tabActive = getUrlParams('tab-active');

            productAjax(
                getUrlParams('search'),
                getUrlParams('pagination'),
                catID,
                catBrandID,
                true,
                tabActive
            );

            $('#archive-products-form').on('submit', function (e) {
                e.preventDefault();

                currentProdPage = 1;
                let keywords = $('#search').val();
                productAjax(keywords, currentProdPage, catID, catBrandID, true, tabActive);
            });

            $('body').on('click', '.archive-products .pagination a', function (e) {
                e.preventDefault();

                if ($(this).hasClass('next')) {
                    currentProdPage += 1;
                } else if ($(this).hasClass('prev')) {
                    currentProdPage -= 1;
                } else {
                    currentProdPage = $(this).html();
                }

                let keywords = $('#search').val();
                productAjax(keywords, currentProdPage, catID, catBrandID, true, tabActive);
            });

            $('body').on('click', '.archive-products__filter__content__item', function (e) {
                e.preventDefault();
                let keywords = $('#search').val();
                currentProdPage = 1;

                if (catBrandID !== '' && catBrandID !== null) {
                    if ($(this).hasClass('active')) {
                        $(this).removeClass('active');
                        catID = '';
                        if (tabActive === 'product-type') {
                            tabActive = '';
                            catBrandID = '';
                        }
                        productAjax(keywords, currentProdPage, catID, catBrandID, true, tabActive);
                    } else {
                        $('.archive-products .archive-products__filter__content__item').removeClass('active');
                        $(this).addClass('active');

                        if (tabActive === 'product-type') {
                            catBrandID = '';
                        }

                        catID = $(this).data('cat-id');
                        productAjax(keywords, currentProdPage, catID, catBrandID, true, tabActive);
                    }
                } else {
                    if ($(this).hasClass('active')) {
                        $(this).removeClass('active');
                        $('.archive-products__filter__content__brand .slick-slider').slick('unslick');
                        $('.archive-products__filter__content__brand .row').remove();
                        catID = '';
                        catBrandID = '';
                        tabActive = '';
                        productAjax(keywords, currentProdPage, catID, catBrandID, false, tabActive);
                    } else {
                        $('.archive-products .archive-products__filter__content__item').removeClass('active');
                        $(this).addClass('active');

                        catID = $(this).data('cat-id');
                        catBrandID = '';
                        tabActive = 'product-type';
                        productAjax(keywords, currentProdPage, catID, catBrandID, true, tabActive);
                    }
                }
            });

            $('body').on('click', '.archive-products__filter__content__item_brand', function (e) {
                e.preventDefault();

                let keywords = $('#search').val();
                currentProdPage = 1;

                if (catID !== '' && catID !== null) {
                    if ($(this).hasClass('active')) {
                        $(this).removeClass('active');
                        catBrandID = '';
                        if (tabActive === 'product-type-brand') {
                            tabActive = '';
                            catID = '';
                        }
                        productAjax(keywords, currentProdPage, catID, catBrandID, true, tabActive);
                    } else {
                        $('.archive-products .archive-products__filter__content__item_brand').removeClass('active');
                        $(this).addClass('active');

                        if (tabActive === 'product-type-brand') {
                            catID = '';
                        }

                        catBrandID = $(this).data('cat-brand-id');
                        productAjax(keywords, currentProdPage, catID, catBrandID, true, tabActive);
                    }
                } else {
                    if ($(this).hasClass('active')) {
                        $(this).removeClass('active');
                        $('.archive-products__filter__content__pt .slick-slider').slick('unslick');
                        $('.archive-products__filter__content__pt .row').remove();
                        catID = '';
                        catBrandID = '';
                        tabActive = '';
                        productAjax(keywords, currentProdPage, catID, catBrandID, false, tabActive);
                    } else {
                        $('.archive-products .archive-products__filter__content__item_brand').removeClass('active');
                        $(this).addClass('active');

                        catID = '';
                        catBrandID = $(this).data('cat-brand-id');
                        tabActive = 'product-type-brand';
                        productAjax(keywords, currentProdPage, catID, catBrandID, true, tabActive);
                    }
                }
            });

            $('body').on('click', '.archive-products__items__stats__reset', function (e) {
                e.preventDefault();

                let keywords = '';
                currentProdPage = 1;
                catID = '';
                catBrandID = '';
                tabActive = '';

                clearFilter(keywords, currentProdPage, catID, catBrandID, tabActive);
            });
        }
    }

    function productType() {
        $('.archive-products__filter__content__pt_slider').slick(archiveProductSlickSettings);
        $('.archive-products__filter__content__brand_slider').slick(archiveProductSlickSettings);
    }

    function productAjax(keywords = '', currentPage = '', catID = '', catBrandID = '', switchTab = true, tabActive = '') {
        if (keywords !== null) {
            insertParam('search', keywords);
        }
        if (currentPage !== null) {
            insertParam('pagination', currentPage);
        }
        if (catID !== null) {
            insertParam('product-type', catID);
        }
        if (catBrandID !== null) {
            insertParam('product-type-brand', catBrandID);
        }

        if (tabActive !== null) {
            insertParam('tab-active', tabActive);
        }

        if (tabActive !== '' && tabActive !== null && tabActive === 'product-type') {
            if (catID !== '' && (catBrandID === '' || catBrandID === null)) {
                brandsAjax(catID, catBrandID, switchTab);
            } else if (catID !== '' && catID !== null && catBrandID !== '' && catBrandID !== null) {
                brandsAjax(catID, catBrandID, switchTab);
            }
        } else if (tabActive !== '' && tabActive !== null && tabActive === 'product-type-brand') {
            if ((catID === '' || catID === null) && catBrandID !== '') {
                productTypeAjax(catID, catBrandID, switchTab);
            } else if (catID !== '' && catID !== null && catBrandID !== '' && catBrandID !== null) {
                productTypeAjax(catID, catBrandID, switchTab);
            }
        } else {
            brandsAjax('', '', false);
            productTypeAjax('', '', false);
        }

        if (keywords !== null || currentPage !== null || catID !== null || catBrandID !== null) {
            var $productLoader = $('.archive-products__items_loader');

            $.ajax({
                url: dsflex_params.ajaxurl,
                type: 'post',
                data: {
                    action: 'product_filter',
                    keywords: keywords,
                    page: currentPage,
                    catID: catID,
                    catBrandID: catBrandID
                },
                dataType: "html",
                beforeSend: function (xhr) {
                    $productLoader.css('display', 'flex');
                },
                success: function (data) {
                    if (data) {
                        $('.archive-products .archive-products__items .container').html(data);
                    }
                },
                complete: function (jqXHR) {
                    archiveProductHeight();
                    $productLoader.css('display', 'none');
                    AOS.refresh();
                    $('html,body').animate({scrollTop: $('.archive-products__filter').offset().top - 75}, 'slow');
                }
            });
        }
    }

    function clearFilter(keywords = '', currentPage = '', catID = '', catBrandID = '', tabActive = '') {
        $('#search').val(keywords);

        productAjax(keywords, currentPage, catID, catBrandID, true, tabActive);
    }

    function productTypeAjax(catID, catBrandID, switchTab = true) {
        $.ajax({
            url: dsflex_params.ajaxurl,
            type: 'post',
            data: {
                action: 'product_filter_type',
                catID: catID,
                catBrandID: catBrandID
            },
            dataType: "html",
            success: function (data) {
                if (data) {
                    $('.archive-products__filter__content__pt').html(data);
                    $('.archive-products__filter__content__pt_slider').slick(archiveProductSlickSettings);
                    if (switchTab) {
                        $('.archive-products__filter__tabs_pt').click();
                    }
                }
            }
        });
    }

    function brandsAjax(catID, catBrandID, switchTab = true) {
        $.ajax({
            url: dsflex_params.ajaxurl,
            type: 'post',
            data: {
                action: 'product_filter_brand',
                catID: catID,
                catBrandID: catBrandID
            },
            dataType: "html",
            success: function (data) {
                if (data) {
                    $('.archive-products__filter__content__brand').html(data);
                    $('.archive-products__filter__content__brand_slider').slick(archiveProductSlickSettings);
                    if (switchTab) {
                        $('.archive-products__filter__tabs_brand').click();
                    }
                }
            }
        });
    }

    function insertParam(key, value) {
        key = encodeURIComponent(key);
        value = encodeURIComponent(value);

        // kvp looks like ['key1=value1', 'key2=value2', ...]
        let kvp = document.location.search.substr(1).split('&');
        let i = 0;

        for (i = 0; i < kvp.length; i++) {
            if (kvp[i].startsWith(key + '=')) {
                let pair = kvp[i].split('=');
                pair[1] = value;
                kvp[i] = pair.join('=');
                break;
            }
        }

        if (i >= kvp.length) {
            kvp[kvp.length] = [key, value].join('=');
        }

        // can return this or...
        let params = kvp.join('&');
        if (kvp[0] === "") {
            params = params.substr(1);
        }

        // reload page with new params
        let refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + params;
        window.history.pushState({path: refresh}, '', refresh);
    }

    function getUrlParams(getParameter) {
        // let urlParams = new URLSearchParams(window.location.search);
        // return urlParams.get(getParameter);
        let results = new RegExp('[\?&]' + getParameter + '=([^&#]*)').exec(window.location.href);
        if (results == null) {
            return null;
        } else {
            return decodeURI(results[1]) || null;
        }
    }

    $.fn.inView = function () {
        //Window Object
        var win = $(window);
        //Object to Check
        obj = $(this);
        //the top Scroll Position in the page
        var scrollPosition = win.scrollTop();
        //the end of the visible area in the page, starting from the scroll position
        var visibleArea = win.scrollTop() + win.height();
        //the end of the object to check
        var objEndPos = (obj.offset().top + obj.outerHeight());
        return (visibleArea >= objEndPos ? true : false)
    };

    // Inquiry List JS
    var menuInquiryTop = 0;

    function inquiryList() {
        $('.inquiry-list').on('click', function (e) {
            e.preventDefault();

            toggleInquiryList('open');
        });

        $('.inquiry-list-block__title_close').on('click', function (e) {
            e.preventDefault();

            toggleInquiryList('close');
        });

        $(document).keyup(function (e) {
            if (e.keyCode === 27 && $('body').hasClass('is-opened')) {
                toggleInquiryList('close');
            }   // esc
        });

        $('body').on('click', '.input-group .button-plus', function (e) {
            incrementValue(e);
        });

        $('body').on('click', '.input-group .button-minus', function (e) {
            decrementValue(e);
        });

        $('body').on('keyup change', '.input-group .quantity-field', function (e) {
            let parentID = $(e.target).parents('.inquiry-list-block__list_item').data('id');
            let currentVal = parseInt($(this).val(), 10);
            let amountIP = 1;

            if (!isNaN(currentVal)) {
                if (currentVal > 1) {
                    $(this).val(currentVal);
                    amountIP = currentVal;
                } else {
                    $(this).val(1);
                    amountIP = 1;
                }
            } else {
                $(this).val(1);
                amountIP = 1;
            }

            setValue(amountIP, parentID);
        });

        $('body').on('click', '.add-inquiry-list', function (e) {
            e.preventDefault();

            let id = $(this).data('id');
            let title = $(this).data('title');
            let imageUrl = $(this).data('image-url');
            let link = $(this).data('link');

            addProductToInquiryList(id, title, imageUrl, link);
            $(this).siblings('.inquiry-msg').fadeIn('slow');
            $(this).siblings('.inquiry-msg').delay(5000).fadeOut('slow');
        });

        $('body').on('click', '.request_quote', function (e) {
            e.preventDefault();

            let id = $(this).data('id');
            let title = $(this).data('title');
            let imageUrl = $(this).data('image-url');
            let link = $(this).data('link');

            addProductToInquiryList(id, title, imageUrl, link);
            toggleInquiryList('open');
            $(this).siblings('.inquiry-msg').fadeIn('slow');
            $(this).siblings('.inquiry-msg').delay(5000).fadeOut('slow');
        });

        $('.inquiry-list-block__form form').on('submit', function (event) {
            $('.inquiry-list-block__loader').css('display', 'flex');
            $('#i_products').val(getCookie('inquiry-list'));
        });

        $('.inquiry-list-block__form > .wpcf7').on('wpcf7mailsent', function (event) {
            setCookie('inquiry-list', [], 1);
            $('.inquiry-list-block__list_item').remove();
            $('.inquiry-list-block__title_number').html(0);
            $('.inquiry-list--number').html('');
            $('.inquiry-list-block__loader').css('display', 'none');
            $('.inquiry-list-block__list-msg').fadeIn('slow').delay(5000).fadeOut('slow');
        });

        $('.inquiry-list-block__form > .wpcf7').on('wpcf7invalid wpcf7mailfailed wpcf7spam', function (e) {
            $('.inquiry-list-block__loader').css('display', 'none');
        });
    }

    function addProductToInquiryList(id, title, imageUrl, link) {
        let cookieName = 'inquiry-list';

        checkCookie(cookieName, id, title, imageUrl, link);
    }

    function removeProductToInquiryList(id) {
        let cookieName = 'inquiry-list';
        let cookieIDs = getCookie(cookieName);
        if (cookieIDs != "") {
            let cookieIDsArray = JSON.parse(cookieIDs);
            let cookieIDsArrayKey = cookieIDsArray.find((o, i) => {
                if (o.id === id) {
                    cookieIDsArray.splice(i, 1);
                    return true;
                }

                return undefined;
            });
            if (cookieIDsArrayKey !== undefined) {
                calculateInquiryProducts(cookieIDsArray);
                cookieIDs = JSON.stringify(cookieIDsArray);
                setCookie(cookieName, cookieIDs, 1);
            }
        }
        $('.inquiry-list-block__list_item[data-id=' + id + ']').remove();
    }

    function checkCookie(name, value, title, imageUrl, link) {
        let cookieIDs = getCookie(name);
        if (cookieIDs != "") {
            let cookieIDsArray = JSON.parse(cookieIDs);
            if (cookieIDsArray.find(o => o.id === value) === undefined) {
                cookieIDsArray.push({
                    id: value,
                    amount: 1
                });
                calculateInquiryProducts(cookieIDsArray);
                cookieIDs = JSON.stringify(cookieIDsArray);
                setCookie(name, cookieIDs, 1);
                appendInquiryListItem(value, title, imageUrl, link);
            }
        } else {
            cookieIDs = [];
            if (value != "" && value != null) {
                cookieIDs.push({
                    id: value,
                    amount: 1
                });
                calculateInquiryProducts(cookieIDs);
                cookieIDs = JSON.stringify(cookieIDs);
                setCookie(name, cookieIDs, 1);
                appendInquiryListItem(value, title, imageUrl, link);
            }
        }
    }

    function setCookie(cname, cvalue, exdays) {
        let d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function appendInquiryListItem(id, title, imageUrl, link) {
        $('.inquiry-list-block__list').append('<div class="inquiry-list-block__list_item" data-id="' + id + '">\n' +
            '                <div class="inquiry-list-block__list_item_image">\n' +
            '                    <a href="' + link + '">\n' +
            '                        <div class="inquiry-list-block__list_item_image_bg"\n' +
            '                             style="background: url(' + imageUrl + ') no-repeat center center;background-size: contain"></div>\n' +
            '                    </a>\n' +
            '                </div>\n' +
            '                <div class="inquiry-list-block__list_item_content">\n' +
            '                    <div class="inquiry-list-block__list_item_content_title">\n' +
            '                        <a href="' + link + '">' + title + '</a>\n' +
            '                    </div>\n' +
            '                    <div class="inquiry-list-block__list_item_content_counter">\n' +
            '                        <div class="input-group">\n' +
            '                            <input type="button" value="-" class="button-minus" data-field="quantity">\n' +
            '                            <input type="number" step="1" max="" value="1" name="quantity" class="quantity-field">\n' +
            '                            <input type="button" value="+" class="button-plus" data-field="quantity">\n' +
            '                        </div>\n' +
            '                    </div>\n' +
            '                </div>\n' +
            '            </div>');
    }

    function calculateInquiryProducts(cookieIDs) {
        let amountIP = 0;
        if (cookieIDs != '' && cookieIDs != null) {
            amountIP = cookieIDs.length;
        }
        if (amountIP > 0) {
            $('.inquiry-list--number').html('(' + amountIP + ')');
        } else {
            $('.inquiry-list--number').html('');
        }
        $('.inquiry-list-block__title_number').html(amountIP);
    }

    function toggleInquiryList(type) {
        let inquiryList = $('#inquiry-list');
        if (type === 'open') {
            $('body').addClass('is-opened');
            menuInquiryTop = $(window).scrollTop();
            $('body').css({
                overflow: 'hidden',
                width: '100%',
                position: 'fixed',
            });
            inquiryList.addClass('active');
        } else if (type === 'close') {
            $('body').removeClass('is-opened');
            $('body').css({
                overflow: '',
                width: '',
                position: '',
            });
            $('html, body').animate({scrollTop: menuInquiryTop}, 0);
            inquiryList.removeClass('active');
        } else if (type === 'toggle') {
            $('body').toggleClass('is-opened');
            if ($('body').attr('style')) {
                $('body').css({
                    overflow: '',
                    width: '',
                    position: '',
                });
                $('html, body').animate({scrollTop: menuInquiryTop}, 0);
            } else {
                menuInquiryTop = $(window).scrollTop();
                $('body').css({
                    overflow: 'hidden',
                    width: '100%',
                    position: 'fixed',
                });
            }
            inquiryList.toggleClass('active');
        }
    }

    function incrementValue(e) {
        e.preventDefault();

        let fieldName = $(e.target).data('field');
        let parent = $(e.target).closest('div');
        let parentID = $(e.target).parents('.inquiry-list-block__list_item').data('id');
        let currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);
        let amountIP = 1;

        if (!isNaN(currentVal)) {
            parent.find('input[name=' + fieldName + ']').val(currentVal + 1);
            amountIP = currentVal + 1;
        } else {
            parent.find('input[name=' + fieldName + ']').val(1);
        }

        setValue(amountIP, parentID);
    }

    function decrementValue(e) {
        e.preventDefault();

        let fieldName = $(e.target).data('field');
        let parent = $(e.target).closest('div');
        let id = $(e.target).parents('.inquiry-list-block__list_item').data('id')
        let currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);
        let amountIP = 1;

        if (!isNaN(currentVal) && currentVal - 1 === 0) {
            removeProductToInquiryList(id);
        } else if (!isNaN(currentVal) && currentVal > 0) {
            parent.find('input[name=' + fieldName + ']').val(currentVal - 1);
            amountIP = currentVal - 1;
            setValue(amountIP, id)
        } else {
            parent.find('input[name=' + fieldName + ']').val(1);
            setValue(amountIP, id)
        }
    }

    function setValue(amountIP, id) {
        let cookieName = 'inquiry-list';
        let cookieIDs = getCookie(cookieName);
        let cookieIDsArray = JSON.parse(cookieIDs);
        let cookieIDsArrayKey = cookieIDsArray.find((o, i) => {
            if (o.id === id) {
                cookieIDsArray[i] = {
                    id: id,
                    amount: amountIP
                }
                return true;
            }

            return undefined;
        });
        if (cookieIDsArrayKey !== undefined) {
            cookieIDs = JSON.stringify(cookieIDsArray);
            setCookie(cookieName, cookieIDs, 1);
        }
    }

    function archiveProductHeight() {
        $(".product__categories").each(function () {
            pasteDotsLength($(this));
        });
        $(".woocommerce-loop-product__title").each(function () {
            pasteDotsLength($(this));
        });
    }

    function pasteDotsLength(el) {
        let $elem = $(el);
        if ($elem[0].scrollHeight > $elem.height()) {
            $elem.addClass('overflows');
        } else {
            $elem.removeClass('overflows');
        }
    }
})(jQuery);